// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ConfigProvider } from 'antd';
import ruRU from 'antd/es/locale/ru_RU';
import moment from 'moment';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
import { store } from './app/providers/redux/store';
import { initAuthInterceptor } from './shared/common/api/middleware';
import 'moment/locale/ru';
moment.locale('ru');

// Подавление ошибки ResizeObserver loop completed with undelivered notifications
// Это безвредная ошибка, возникающая при быстром изменении размеров элементов (таблицы, тултипы и т.д.)
const resizeObserverErr = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.style.display = 'none';
    }
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErr);


initAuthInterceptor().finally(() => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ConfigProvider locale={ruRU}>
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );


});
